import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-433b0d3f"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "new-company"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  class: "form-wrapper"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconxiangxiajiantou21"
  }, null, -1);
});

var _hoisted_5 = {
  key: 0,
  class: "error-tip"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconMask3"
  }, null, -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode("上一步");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("完成");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("提交申请");

var _hoisted_10 = /*#__PURE__*/_createTextVNode("返回");

var _hoisted_11 = /*#__PURE__*/_createTextVNode("保存");

import { ElMessage } from 'element-plus';
import { reactive, ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { updateCompanyTip } from '@/config/constant';
import { modifyTip } from '@/config/company';
import { checkPhone } from '@/utils/validate';
import { dispatchAction } from '@/store/utils';
import CompanyService from '@/api/company';
export default /*#__PURE__*/_defineComponent({
  props: {
    status: {
      type: String,
      default: 'new'
    },
    isPaidCreate: {
      type: Boolean,
      default: false
    }
  },
  emits: ['comfirm', 'cancel'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var formRef = ref();
    var nameError = ref('');
    var industryError = ref('');
    var contactError = ref('');
    var phoneError = ref('');
    var isCompanyAdmin = ref(false);
    var inputLegal = ref(false);
    var appCheckedList = ref([]);
    var industryList = computed(function () {
      return store.state.company.industryList;
    });
    var formState = reactive({
      name: '',
      contact: '',
      phone: '',
      industry: undefined
    });

    var checkInputStatus = function checkInputStatus() {
      inputLegal.value = !nameError.value && !industryError.value && !contactError.value && !phoneError.value && !!formState.name && !!formState.contact && !!formState.phone && !!formState.industry;
    }; // 校验账户名称


    var validateName = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nameError.value = value !== null && value !== void 0 && value.trim() ? '' : updateCompanyTip.emptyName;
                nameError.value = (value === null || value === void 0 ? void 0 : value.trim().length) > 20 ? updateCompanyTip.nameTooLong : nameError.value;
                checkInputStatus();
                nameError.value ? callback(nameError.value) : callback();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function validateName(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }(); // 校验行业


    var validateIndustry = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                industryError.value = value ? '' : updateCompanyTip.emptyIndustry;
                checkInputStatus();
                industryError.value ? callback(industryError.value) : callback();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function validateIndustry(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }(); // 校验联系人


    var validateContact = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                contactError.value = value !== null && value !== void 0 && value.trim() ? '' : updateCompanyTip.emptyContact;
                contactError.value = (value === null || value === void 0 ? void 0 : value.trim().length) > 20 ? updateCompanyTip.contactTooLong : contactError.value;
                checkInputStatus();
                contactError.value ? callback(contactError.value) : callback();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function validateContact(_x7, _x8, _x9) {
        return _ref4.apply(this, arguments);
      };
    }(); // 校验手机号


    var validatePhone = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                phoneError.value = checkPhone(value, true) ? updateCompanyTip.invalidPhone : '';
                checkInputStatus();
                phoneError.value ? callback(phoneError.value) : callback();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function validatePhone(_x10, _x11, _x12) {
        return _ref5.apply(this, arguments);
      };
    }();

    var rules = {
      name: [{
        validator: validateName,
        trigger: 'blur'
      }],
      industry: [{
        validator: validateIndustry,
        trigger: 'blur'
      }],
      contact: [{
        validator: validateContact,
        trigger: 'blur'
      }],
      phone: [{
        validator: validatePhone,
        trigger: 'blur'
      }]
    }; // 创建企业

    var createCompany = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _industryList$value$f;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                emit('comfirm', _objectSpread(_objectSpread({}, formState), {}, {
                  industryName: (_industryList$value$f = industryList.value.find(function (item) {
                    return item.id === formState.industry;
                  })) === null || _industryList$value$f === void 0 ? void 0 : _industryList$value$f.first
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function createCompany() {
        return _ref6.apply(this, arguments);
      };
    }(); // 更新企业信息


    var modifyCompany = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _route$query$id;

        var corporationId, data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                corporationId = ((_route$query$id = route.query.id) === null || _route$query$id === void 0 ? void 0 : _route$query$id.toString()) || '';
                _context6.next = 3;
                return CompanyService.updateNopassCompany({
                  corporation_id: corporationId
                }, {
                  corporation_name: formState.name,
                  industry_id: formState.industry,
                  contact: formState.contact,
                  phone: formState.phone,
                  app_keys: appCheckedList.value.join(';')
                });

              case 3:
                data = _context6.sent;

                if (data.data.code === 1) {
                  ElMessage({
                    message: modifyTip.updateSuccess,
                    type: 'success'
                  });
                  router.push('/company/list');
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function modifyCompany() {
        return _ref7.apply(this, arguments);
      };
    }(); // 提交保存


    var submitForm = function submitForm(formEl) {
      if (!formEl) return;
      formEl.validate(function (valid) {
        if (valid) {
          props.status === 'modify' ? modifyCompany() : createCompany();
        } else {
          return false;
        }
      });
    }; // 前往无企业信息页


    var goCompanyPage = function goCompanyPage() {
      emit('cancel');
    }; // 创建企业初始化


    var iniCreateInfo = function iniCreateInfo() {
      Promise.all([dispatchAction('company', 'getIndustryList', {}), dispatchAction('company', 'getPlatformList', {})]);
    }; // 初始化企业修改信息


    var initModifyInfo = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _route$query$id2;

        var corporationId;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                corporationId = ((_route$query$id2 = route.query.id) === null || _route$query$id2 === void 0 ? void 0 : _route$query$id2.toString()) || '';
                Promise.all([CompanyService.getCompanyDetail({
                  corporation_id: corporationId
                }), dispatchAction('company', 'getIndustryList', {}), dispatchAction('company', 'getPlatformList', {
                  corporationId: corporationId
                })]).then(function (result) {
                  var detail = result[0].data.result;
                  formState.name = detail.corporation_name;
                  formState.contact = detail.contact;
                  formState.phone = detail.phone;
                  formState.industry = detail.industry_id;
                  appCheckedList.value = detail.app_keys;
                  isCompanyAdmin.value = store.state.company.isAdmin;
                });

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function initModifyInfo() {
        return _ref8.apply(this, arguments);
      };
    }(); // init


    props.status === 'modify' ? initModifyInfo() : iniCreateInfo();
    return function (_ctx, _cache) {
      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return __props.status === 'modify' || __props.status === 'new' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.status !== 'new' ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "企业信息")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: _unref(formState),
        "status-icon": "",
        rules: rules,
        "label-width": 68,
        width: 478,
        inline: true,
        class: "demo-ruleForm"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: "企业名称",
            prop: "name"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                class: "custom-input",
                modelValue: _unref(formState).name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).name = $event;
                }),
                placeholder: "",
                autocomplete: "off"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "所属行业",
            prop: "industry"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_select, {
                "show-arrow": true,
                class: "custom-select",
                modelValue: _unref(formState).industry,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(formState).industry = $event;
                }),
                style: {
                  "width": "280px"
                },
                placeholder: "请选择"
              }, {
                suffixIcon: _withCtx(function () {
                  return [_hoisted_4];
                }),
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(industryList), function (item) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      value: item.id,
                      label: item.first,
                      key: item.id
                    }, {
                      default: _withCtx(function () {
                        return [_createTextVNode(_toDisplayString(item.first), 1)];
                      }),
                      _: 2
                    }, 1032, ["value", "label"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["modelValue"]), industryError.value ? (_openBlock(), _createElementBlock("p", _hoisted_5, [_hoisted_6, _createTextVNode(" " + _toDisplayString(industryError.value), 1)])) : _createCommentVNode("", true)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "联系人",
            prop: "contact"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                class: "custom-input",
                modelValue: _unref(formState).contact,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(formState).contact = $event;
                }),
                placeholder: "请输入姓名",
                autocomplete: "off"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "联系电话",
            prop: "phone"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                class: "custom-input",
                modelValue: _unref(formState).phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return _unref(formState).phone = $event;
                }),
                placeholder: "请输入手机号",
                autocomplete: "off"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), __props.status === 'new' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0
          }, {
            default: _withCtx(function () {
              return [__props.isPaidCreate ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                class: "custom-button cancel-button",
                onClick: goCompanyPage
              }, {
                default: _withCtx(function () {
                  return [_hoisted_7];
                }),
                _: 1
              })) : _createCommentVNode("", true), __props.isPaidCreate ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                disabled: !inputLegal.value,
                class: "custom-button submit-button",
                type: "primary",
                onClick: _cache[4] || (_cache[4] = function ($event) {
                  return submitForm(formRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_8];
                }),
                _: 1
              }, 8, ["disabled"])) : (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                disabled: !inputLegal.value,
                class: "custom-button submit-button",
                type: "primary",
                onClick: _cache[5] || (_cache[5] = function ($event) {
                  return submitForm(formRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_9];
                }),
                _: 1
              }, 8, ["disabled"]))];
            }),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                class: "custom-button cancel-button",
                onClick: goCompanyPage
              }, {
                default: _withCtx(function () {
                  return [_hoisted_10];
                }),
                _: 1
              }), _createVNode(_component_el_button, {
                class: "custom-button submit-button",
                type: "primary",
                onClick: _cache[6] || (_cache[6] = function ($event) {
                  return submitForm(formRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_11];
                }),
                _: 1
              })];
            }),
            _: 1
          }))];
        }),
        _: 1
      }, 8, ["model"])])])) : _createCommentVNode("", true);
    };
  }
});